import React, { useState, useEffect } from 'react';
import ItemsCarousel from 'react-items-carousel';

import { LazyLoadImage } from 'react-lazy-load-image-component';
const sx = {
  hoverStyle: {
    '&:hover': {
      position: 'relative',
      transform: 'translateY(-10px)',
      webkitBoxShadow: '0px 13px 32px 0px rgba(0,0,0,0.24)',
      mozBoxShadow: '0px 13px 32px 0px rgba(0,0,0,0.24)',
      boxShadow: '0px 13px 32px 0px rgba(0,0,0,0.24) !important',
    },
  },
};
const autoPlayDelay = 2000;
const chevronWidth = 40;
const Carousel = ({ collections, onClick }) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [noOfCards, setNoOfCards] = useState(5);

  const tick = () => {
    let active = activeItemIndex + 1;
    setActiveItemIndex(active);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      tick();
    }, autoPlayDelay);
    return () => clearInterval(interval);
  }, [activeItemIndex]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.innerWidth < 1200) {
      setNoOfCards(4);
    }
    if (window.innerWidth < 899) {
      setNoOfCards(3);
    }
    if (window.innerWidth < 600) {
      setNoOfCards(2);
    }
    if (window.innerWidth < 400) {
      setNoOfCards(1);
    }
  }, []);
  return (
    <>
      <div
        style={{
          marginTop: '-1px',
          marginBottom: '50px',
        }}
      >
        <ItemsCarousel
          requestToChangeActive={setActiveItemIndex}
          activeItemIndex={activeItemIndex}
          numberOfCards={noOfCards}
          gutter={9}
          infiniteLoop
        >
          {collections.map((collect, index) => (
            <img
              key={index}
              src={collect.img}
              style={{
                height: '98%',
                width: '98%',
                borderRadius: '15px',
                cursor: 'pointer',
              }}
              alt="img"
              onClick={() => {
                onClick(index);
              }}
            />
          ))}
        </ItemsCarousel>
        <br></br>
      </div>
    </>
  );
};

export default Carousel;
